import React from "react";
import { Button } from "@material-ui/core";
const DeleteItem = ({ name, selectedItem, handleDelete, handleShowModal }) => {
  const _handleDelete = item => {
    if (handleDelete && typeof handleDelete === "function") {
      handleDelete(item);
    }
  };
  const _handleShowModal = isOpen => {
    if (handleShowModal && typeof handleShowModal === "function") {
      handleShowModal(isOpen);
    }
  };
  const renderDescription = () => {
    switch (name) {
      case "user":
        return (
          <div>
            {selectedItem.firstName} {selectedItem.lastName}
          </div>
        );
      case "property":
        return <div>{selectedItem.address || selectedItem.id}</div>;
      default:
        return <div>{selectedItem.address || selectedItem.id}</div>;
    }
  };
  return (
    <>
      <div className="deleteItem">
        <div className="deleteItem-title">
          Are you sure to delete {name} {renderDescription()}
        </div>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => _handleDelete(selectedItem)}
        >
          Yes, I'm sure
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => _handleShowModal(false)}
        >
          No
        </Button>
      </div>
    </>
  );
};
export default DeleteItem;
